import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'
import { useArticles } from 'utils/api/hooks'
import Link from 'components/common/A'
import CursorBox from 'components/common/CursorPointerBox.js'

const ImgRect = styled.div`
  width: 105px;
  height: 79px;
  min-width: 105px;
  min-height: 79px;
  border-radius: 5px;
  overflow: hidden;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
`

const LatestArticle = (prop) => {
  const { data: articles, isLoading: isArticleLoading } = useArticles()

  return (
    <>
      {!isArticleLoading && (
        <Grid container mb={12} {...prop}>
          <Typography mb={6} fontWeight="fontWeightBold">
            最新上架
          </Typography>
          <Grid item xs={12}>
            {articles &&
              articles?.slice(0, 3).map((item, index) => {
                return (
                  <Link
                    href={`/article/${item?.urlId}`}
                    target="_blank"
                    key={item._id}
                  >
                    <CursorBox
                      display="flex"
                      alignItems="center"
                      mb={index < articles.length - 1 ? 6 : 0}
                    >
                      <ImgRect>
                        <Img
                          alt=""
                          src={
                            item.image?.url || '/img/img_headshot_default.png'
                          }
                        />
                      </ImgRect>

                      <Typography
                        variant="paraBodyMedium"
                        color="text.minus2"
                        mt={3}
                        mx={2}
                      >
                        {item?.title}
                      </Typography>
                    </CursorBox>
                  </Link>
                )
              })}
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default LatestArticle
